import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TemplateItemTemplate } from '../../../../../Model/Catalog/TemplateItemTemplate';
import { FieldListInterface } from '../../../../../Model/ui/FieldListInterface';
import { SearchForm } from '../../../../../Model/Dto/SearchForm';
import { TranslateService } from "@ngx-translate/core";
import { ValueChangedEvent } from "devextreme/ui/check_box";

@Component({
    selector: 'fieldList',
    templateUrl: './fieldList.component.html',
    styleUrls: ['./fieldList.component.css'],
    standalone: false
})
export class FieldListComponent implements OnInit {
    @Input() set fieldListContainer(value: FieldListInterface) {
        this._fieldListContainer = value;
        this.selectFieldsFromConfig();
    }

    @Input() fields: TemplateItemTemplate[];
    @Input() defaultFields: string[] = ['SUPPLIER_PID'];
    @Input() fieldGroups: string[];
    @Input() isUpdateTemplate: boolean = false;
    @Input() isExportParameter: boolean = false;
    @Input() activeSearchForm: SearchForm;

    @Output() onValueChanged = new EventEmitter();

    get fieldListContainer() {
        return this._fieldListContainer;
    }

    _fieldListContainer: FieldListInterface;
    groups: { name: string; active: boolean }[];

    constructor(
        public translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        if (this.fieldListContainer.fields == null) this.fieldListContainer.fields = Object.assign([], this.defaultFields);

        this.selectFieldsFromConfig();

        if (this.activeSearchForm?.searchOptions) {
            this.setFieldsBySearchForm();
        }
    }

    get allActive(): boolean {
        return this.fields.every(field => !this.groups.some(group => group.name == field.group) || field.active);
    }

    selectAll(event: ValueChangedEvent) {
        if (!event.event)
            return;

        this.groups.forEach(group => {
            this.selectGroup(event, group.name);
            group.active = event.value;
        });
        this.syncFieldWithConfig();
        this.onValueChanged.emit({ event: 'fieldListAllChanged' });
    }

    selectGroup(event: ValueChangedEvent, groupname: string) {
        for (let field of this.fields) {
            if (field.group == groupname) {
                if (field.field != 'SUPPLIER_PID') {
                    field.active = event.value;
                }
            }
        }
        this.syncFieldWithConfig();
        this.onValueChanged.emit({ event: 'fieldListGroupChanged' });
    }

    selectField(event: ValueChangedEvent, field: any) {
        if (event.event != null) {
            this.syncFieldWithConfig();
            this.onValueChanged.emit({ event: 'fieldListFieldChanged' });
        }
    }

    isFieldAllowed(field: TemplateItemTemplate): boolean {

        if (this.isUpdateTemplate && field.field == "CAT_GROUP_ID")
            return false;
        if (this.isUpdateTemplate && field.field == "CAT_STABLE_ID")
            return false;
        if (field.field == "PRODUCT_ORDER")
            return false;
        return true;
    }

    syncFieldWithConfig() {
        if (this.fieldListContainer.fields == null) this.fieldListContainer.fields = Object.assign([], this.defaultFields);

        this.fieldListContainer.fields = this.fields.filter((x) => x.active).map((x) => x.field);
    }

    selectFieldsFromConfig() {
        if (this.fieldListContainer.fields == null) this.fieldListContainer.fields = Object.assign([], this.defaultFields);

        this.fields.forEach((x) => {
            x.active = this.fieldListContainer.fields.some((y) => y == x.field);
        });

        this.groups = this.fieldGroups.map((x) => {
            return { name: x, active: false };
        });
        this.groups.forEach((x) => {
            x.active = !this.fields?.some((y) => y.group == x.name && !y.active);
        });
    }

    getHeightRatio(group: string): number {
        var list = this.fields?.filter((item) => item.group == group);
        return list.length + 2;
    }

    protected setFieldsBySearchForm() {
        var searchForm = this.activeSearchForm;
        if (searchForm == null) return;
        this.fields.forEach((x) => {
            x.active = searchForm.searchOptions.some((y) => y.nextPimField?.field == x.field);
        });
        this.syncFieldWithConfig();
        this.groups.forEach((x) => {
            x.active = !this.fields?.some((y) => y.group == x.name && !y.active);
        });
        this.onValueChanged.emit({ event: 'fieldListFieldChanged' });
    }
}
